import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import Grid from '@mui/material/Grid';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/system/Box';

import { totalUserOnline } from "./Services";
import WWMainbox from "../../Components/AdminComponents/WWMainbox";

import StatisticsDashboard from './StatisticsDashboard';
import LearnerLeaderBoard from "./LearnerLeaderBoard";
import TrainerLeaderBoard from "./TrainerLeaderBoard";

// import AssignProductToClass from "./AssignProductToClass";

const Dashboard = (props) => {

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

    //State
    const [tabValue, setTabValue] = useState('statistics');
    const [onlineUsersData, setOnlineUsersData] = useState(null);

    // React initial executed
    useEffect(() => {
        const timer = setTimeout(() => {
            // console.log('Dashboard time out online user data!')
            getOnlineUsers();
          }, 5000);
          return () => clearTimeout(timer);
    }, [onlineUsersData]);

    //getOnlineUsers
    const getOnlineUsers = async () => {
        let resOnlineUsers = await totalUserOnline({ 'site_uuid': userInfo.site_uuid });
        // console.log("resOnlineUsers3333333======>",resOnlineUsers.data);    
        setOnlineUsersData(resOnlineUsers.data);
    };

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Grid container >
            <Grid item xs={12} sx={{ mx: 6 }}>
                <Grid item xs={12} sx={{}}>
                    {onlineUsersData &&
                        <WWMainbox onlineUsersData={onlineUsersData} />
                    }
                </Grid>
                <Grid item xs={12} sx={{ mt: 1 }}>
                    <Box sx={{ width: '100%', typography: 'body1', textAlign: 'center' }}>
                        <TabContext value={tabValue}>
                            <Box sx={{ display: 'inline-flex', borderBottom: 1, borderBlockColor: '#EFEFEF', width: '100%', justifyContent: 'center' }}>
                                <TabList onChange={handleChange} aria-label="API tabs">
                                    <Tab label="Statistics" value="statistics" sx={{ textTransform: 'inherit', fontWeight: '600', color:'#5f5600ff', fontSize: '1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'}  }} />
                                    <Tab label="Learners' Leader Board" value="learner_leader_board" sx={{ textTransform: 'inherit', ml: 15, fontWeight: '600', color:'#5f5600ff' , fontSize: '1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'}   }} />
                                    <Tab label="Trainer Leader Board" value="trainer_leader_board" sx={{ textTransform: 'inherit', ml: 15, fontWeight: '600', color:'#5f5600ff', fontSize: '1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'}    }} />
                                </TabList>
                            </Box>
                            <TabPanel value="statistics">
                                <StatisticsDashboard />
                            </TabPanel>
                            <TabPanel value="learner_leader_board">
                                <LearnerLeaderBoard />
                            </TabPanel>
                            <TabPanel value="trainer_leader_board">
                                <TrainerLeaderBoard />
                            </TabPanel>
                        </TabContext>
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Dashboard;